import { useState, useEffect } from 'react'

const useDeviceDetection = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false)

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth
      // const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0

      if (width < 700) {
        setIsMobileDevice(true)
      } else {
        setIsMobileDevice(false)
      }
    }

    checkDevice()

    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [])

  return isMobileDevice
}

export default useDeviceDetection
